import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SidebarService } from '../../core/services/sidebar.service';
import { SecurityService } from '../../core/services/security.service';
import { UserFunctions } from '../../core/enums/security-functions.enum';
import type { SidebarOption } from '../../core/models/sidebar-option';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  public sidebar = inject(SidebarService);
  private router = inject(Router);
  private userFunctions = inject(SecurityService).getUserFunctions();

  options = signal<SidebarOption[]>([]);
  openSubmenus = signal<Set<string>>(new Set());

  ngOnInit(): void {
    const sidebarOptions:SidebarOption[] = [];

    if(this.userFunctions === null){
      return;
    }

    // sidebarOptions.push({
    //   label: "Home",
    //   icon: "fa-solid fa-house",
    //   route: "/home"
    // });

    if (this.userFunctions.includes(UserFunctions.Legos_Visualizar)) {
      const legajosChildren: SidebarOption[] = [
        { label: 'Inicio', route: '/legajos' },
        // { label: 'Mis Legajos', route: '/legajos/mis-legajos' },
        { label: 'Listado General', route: '/legajos/listado-general' }
      ];
      if (this.userFunctions.includes(UserFunctions.Legos_Editar)) {
        legajosChildren.push({ label: 'Nuevo', route: '/legajos/nuevo' });
      }
      // if (this.userFunctions.includes(UserFunctions.Legos_Administrar)) {
      //   legajosChildren.push({ label: 'Plantillas', route: '/legajos/admin/plantillas' });
      //   legajosChildren.push({ label: 'Valores Maestros', route: '/legajos/admin/maestros' });
      // }
      sidebarOptions.push({
        label: 'Legajos Técnicos',
        icon: 'fa-solid fa-folder-open',
        children: legajosChildren
      });
    }

    if (this.userFunctions.includes(UserFunctions.Seguridad_Consulta)) {
      const children:SidebarOption[] = [{
        label: "Consulta",
        route: "/roles"
      }];
      if (this.userFunctions.includes(UserFunctions.Seguridad_Administracion)) {
        children.push({
            label: "Nuevo",
            route: "/roles/nuevo"
        });
      }
      sidebarOptions.push({
        label: "Roles",
        icon: "fa-solid fa-shield-halved",
        children: children
      });
    }

    this.options.set(sidebarOptions);
  }

  toggleSubmenu(option: SidebarOption) {
    if (!option.children) {
      return;
    }

    if (this.sidebar.isCollapsed()) {
      this.sidebar.expand();
    }

    const set = new Set(this.openSubmenus());
    set.has(option.label) ? set.delete(option.label) : set.add(option.label);
    this.openSubmenus.set(set);
  }

  isSubmenuOpen(option: SidebarOption) {
    return this.openSubmenus().has(option.label);
  }

  /** Devuelve true si el padre o alguno de sus hijos está activo */
  isParentActive(option: SidebarOption): boolean {
    const currentUrl = this.router.url;
    if (option.children?.some(child => child.route != undefined && currentUrl.startsWith(child.route))) {
      return true;
    }
    if(option.route == undefined) return false;

    return this.router.isActive(option.route, false);
  }
}
